import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	Avatar,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/CheckCircle';

import gradients from '../../../../utils/gradients';

import { NotificationMarkAsRead } from '../../../../actions';

const useStyles = makeStyles((theme) => ({
	root: {},
	listItem: {
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: theme.palette.background.default,
		},
	},
	avatarBlue: {
		backgroundImage: gradients.blue,
	},
	avatarGreen: {
		backgroundImage: gradients.green,
	},
	avatarOrange: {
		backgroundImage: gradients.orange,
	},
	avatarRed: {
		backgroundImage: gradients.red,
	},
	arrowForwardIcon: {
		color: theme.palette.icon,
	},
}));

const NotificationList = (props) => {
	const { notifications, className, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();

	const avatars = {
		info: (
			<Avatar className={classes.avatarBlue}>
				<AnnouncementIcon />
			</Avatar>
		),
		warning: (
			<Avatar className={classes.avatarOrange}>
				<WarningIcon />
			</Avatar>
		),
		success: (
			<Avatar className={classes.avatarGreen}>
				<CheckIcon />
			</Avatar>
		),
		error: (
			<Avatar className={classes.avatarRed}>
				<ErrorIcon />
			</Avatar>
		),
	};

	const handleNotificationClick = (id) => {
		dispatch(NotificationMarkAsRead(id));
	};

	return (
		<List
			{...rest}
			className={clsx(classes.root, className)}
			disablePadding
		>
			{notifications.map((notification, i) => (
				<ListItem
					className={classes.listItem}
					style={!notification.readed ? { backgroundColor: '#eeeeee' } : {}}
					divider={i < notifications.length - 1}
					key={`notificationItem${notification.id}`}
					onClick={() => (!notification.readed ? handleNotificationClick(notification.id) : {})}
				>
					<ListItemAvatar>
						{avatars[notification.icon]}
					</ListItemAvatar>
					<ListItemText
						primary={notification.title}
						primaryTypographyProps={{ variant: 'body1' }}
						secondary={notification.addedDate}
					/>
					<ArrowForwardIcon className={classes.arrowForwardIcon} />
				</ListItem>
			))}
		</List>
	);
};

NotificationList.propTypes = {
	className: PropTypes.string,
	notifications: PropTypes.array.isRequired,
};

export default NotificationList;
